
export type Point = { x: number; y: number };

export enum TowerType {
  ARCHER = 'ARCHER',
  BARRACKS = 'BARRACKS',
  MAGE = 'MAGE',
  ARTILLERY = 'ARTILLERY'
}

export enum TowerBranch {
  NONE = 'NONE',
  PATH_A = 'PATH_A',
  PATH_B = 'PATH_B'
}

export interface Slot extends Point {
  isLocked: boolean;
  unlockCost: number;
}

export enum EnemyType {
  ORC = 'ORC',
  WOLF = 'WOLF',
  SHAMAN = 'SHAMAN',
  BOSS = 'BOSS'
}

export enum ThemeType {
  FOREST = 'FOREST',
  DESERT = 'DESERT',
  SNOW = 'SNOW',
  CAVE = 'CAVE',
  VOLCANO = 'VOLCANO',
  WASTELAND = 'WASTELAND'
}

export interface Mission {
  id: number;
  theme: ThemeType;
  path: Point[];
  slots: Slot[];
  waves: number;
}

export type GameState = 'MENU' | 'CAMPAIGN' | 'PLAYING' | 'SETTINGS' | 'GAMEOVER' | 'VICTORY';

export interface TowerStats {
  cost: number;
  range: number;
  damage: number;
  cooldown: number;
  color: string;
}

export interface EnemyStats {
  health: number;
  speed: number;
  reward: number;
  color: string;
  size: number;
}
